import { IObservable, Observable } from "thrive-observable-react"

import { chatLocalisationDefaults } from "../constants"

import { ChatState, ScreenState,IChatLocalisationStrings, IParentHttpClient, IUser } from "../interfaces"
import { ConversationService } from "./ChatConversation.Service"
import { CS } from "./Chat.Service"
import { getToken } from "../utility/auth"

class ChatAppService {

    public chatParticipantsNameForTitle: IObservable<string> = Observable<string>('') 
    
    public ParentHttpClient!: IParentHttpClient

    public localisationStrings!: IChatLocalisationStrings

    public chatState: IObservable<ChatState> = Observable<ChatState>(ChatState.INITIAL);

    public conversationState: IObservable<ScreenState> = Observable<ScreenState>(ScreenState.INACTIVE);

    public isInSmallViewport: IObservable<boolean> = Observable<boolean>(false);

    public isInActiveConversation: IObservable<boolean> = Observable<boolean>(false);

    public peopleSearchScreenState: IObservable<ScreenState> = Observable<ScreenState>(ScreenState.INACTIVE);
    
    public isInPeopleSearch: IObservable<boolean> = Observable<boolean>(false);

    public brandingColours:IObservable<{bgColor:string, fontColor:string}> = Observable<{bgColor:string, fontColor:string}>({bgColor: '#2f234f', fontColor: 'white'})

    public init({httpClient, localisationStrings}: {httpClient: IParentHttpClient, localisationStrings?: IChatLocalisationStrings, someOtherValue?: string}) : void {
        this.ParentHttpClient = httpClient;
        this.localisationStrings = localisationStrings ?? chatLocalisationDefaults
        this.peopleSearchScreenState.subscribe(() => this.updateIsInPeopleSearch());
        this.conversationState.subscribe(() => this.updateIsInActiveConversation());
        this.isInSmallViewport.subscribe(() => this.updateIsInActiveConversation());
    }

    public setChatState(newState: ChatState) {
        this.chatState.update(newState);
    }

    public setConversationState(newState: ScreenState) {
        this.conversationState.update(newState);
    }
    
    public setIsInSmallviewport(isSmall: boolean) {
        this.isInSmallViewport.update(isSmall);
    }

    private updateIsInActiveConversation() {
        const isActive = this.conversationState.value === ScreenState.ACTIVE

        this.isInActiveConversation.update(isActive);
    }

    public setPeopleSearchScreenState(newState: ScreenState) {
        this.peopleSearchScreenState.update(newState);
    }
    
    private updateIsInPeopleSearch() {
        const isActive = this.peopleSearchScreenState.value === ScreenState.ACTIVE
        this.isInPeopleSearch.update(isActive);
    }

    public goBackToMenu(){
        this.setPeopleSearchScreenState(ScreenState.INACTIVE);
        this.setConversationState(ScreenState.INACTIVE);
    }

    public setOpenChatState() {
        this.setChatState(ChatState.CHAT);
        this.setConversationState(ScreenState.ACTIVE);
        this.setPeopleSearchScreenState(ScreenState.INACTIVE);
    }

    public openChat(chatId:number){
        ConversationService.setChatId(Number(chatId));
        this.setOpenChatState();
    }

    public async checkForExistingChat(user: IUser) {

        
       
        const chatId = await CS.getChatId(user.id);
        
        if (!chatId) {
            ConversationService.setNewChatUserDetails(user);
        }
        this.openChat(chatId);
    }

    public openPeopleSearch() {
        CS.showNewChatPlaceholder();
        ConversationService.setChatId(0);
        ConversationService.setNewChatUserDetails(null);
        this.setChatState(ChatState.PEOPLESEARCH);
        this.setPeopleSearchScreenState(ScreenState.ACTIVE);
        this.setConversationState(ScreenState.INACTIVE);
    }

    public setBranding({bgColor, fontColor}: {bgColor:string, fontColor:string}) {
        this.brandingColours.update({bgColor, fontColor})
    }

    public setNameForPageTitle(users?: IUser[]) {
        if(!users) {
            this.chatParticipantsNameForTitle.update("")
            return;
        }
        const user = CS.getChatRecipientFromUsers(users)
        this.chatParticipantsNameForTitle.update(user.displayName)
    }

    public getAccessToken() {
        return getToken();
    }

    public cleanup() {
        this.chatState.update(ChatState.INITIAL);

    this.conversationState.update(ScreenState.INACTIVE);

    this.isInSmallViewport.update(false);

    this.isInActiveConversation.update(false);

    this.peopleSearchScreenState.update(ScreenState.INACTIVE);
    
    this.isInPeopleSearch.update(false);
    }
}

export const CAS:ChatAppService = new ChatAppService();